import { getLastCategoryLevel } from '@/helpers/getLastCategoryLevel'
import { setFitmentFilters } from '@/helpers/algolia'

export const updateSearch = async (ctx, store, route) => {
    const searchCtx = ctx.$search.catalog
    const catalogData = store.state.catalog.data
    const fitmentData = store.state.fitment.data
    const sitewideData = ctx.$sitewideData

    // Clear out all filters to begin with
    searchCtx.clearFilters()

    // We don't show accessories so set that
    searchCtx.addFilters('isAccessory', 'false')

    // We don't show replacement parts on brand pages
    if (route.name === 'brand') searchCtx.addFilters('isReplacementPart', 'false')

    // Set Facets for current category. Facets must be defined for a refinement to be applied.
    setFacetAttributes(searchCtx, route, catalogData, ctx.$sitewideData)

    // Set filters based upon current fitment
    setFitmentFilters(searchCtx, fitmentData)

    // Set filters based upon route information
    setRouteFilters(searchCtx, route)

    // Set filters if on Facet Landing Page.
    // We can support any number of facet names and values.
    // The values come from the story so we need to make sure that we are on a category custom page,
    // Otherwise they could set these values on a normal category which would have unintended side effects.
    if (route.name.includes('category-custom') && catalogData.story) {
        // Extract an array of facets from content
        const facets = Object.entries(catalogData.story.content)
            .filter(([key, value]) => key.startsWith('facetName') && value)
            .map(([facetKey, facetKeyValue]) => {
                const facetNumber = facetKey.replace('facetName', '')
                const facetValue = catalogData.story.content[`facetValue${facetNumber}`]
                const values = facetValue
                    .split(',')
                    .map((v) => v.trim())
                    .filter((v) => v)
                if (values.length > 0) searchCtx.addFilters(facetKeyValue, values) // split comma-separated values only in facetValue
                return facetKeyValue
            })

        // Remove the facet set for the custom category
        if (ctx.$storyblok.isPreview) {
            searchCtx.state.searchParameters.facets =
                searchCtx.state.searchParameters.facets.filter((facet) => !facets.includes(facet))
        }
    }

    // Set state based upon the route query
    searchCtx.syncFromRoute(route)

    // We need to make sure we can show results with the sameDayShipping facet applied.
    // If we can't show it, then we need to make sure we clear out that refinement after we sync'd our state from the route.
    if (
        sitewideData.config.sameDayShippingEnabled &&
        searchCtx.isRefined('sameDayShipping') &&
        !store.getters['fitment/hasFullFitment']
    ) {
        searchCtx.clearRefinements('sameDayShipping')
    }

    // trigger the actual search to update the data.
    await searchCtx.search()
}

const setFacetAttributes = (searchCtx, route, catalogData, sitewideData) => {
    const lastLevel = getLastCategoryLevel(route)
    let targetLevel = 0

    if (lastLevel !== undefined) targetLevel = lastLevel + 1
    else if (sitewideData.config.useSecondLevel) targetLevel = 1

    searchCtx.state.searchParameters.facets = [
        ...catalogData.facets.map(({ facet }) => facet),
        `categories.lvl${targetLevel}.text`,
        `categories.lvl${targetLevel}.slug`,
    ]

    // the showSameDayShippingFacet checks if the site has it enabled and if the page you are on requests it as a facet.
    if (catalogData.showSameDayShippingFacet)
        searchCtx.state.searchParameters.facets.push('sameDayShipping')
}

const setRouteFilters = (searchCtx, route) => {
    if (!route.params) return

    const lastLevel = getLastCategoryLevel(route)

    if (lastLevel !== undefined) {
        const arr = []

        for (let i = 0; i <= lastLevel; i++) arr.push(route.params[`lvl${i}`])

        searchCtx.addFilters(`categories.lvl${lastLevel}.slug`, arr.join('|'))
    }

    if (route.name.includes('brand')) searchCtx.addFilters('brandSlug', route.params.brandSlug)

    if (route.name.includes('specials')) searchCtx.addFilters('hasSpecial', 'true')

    if (route.name.includes('new-products')) searchCtx.addFilters('isNew', 'true')
}
